import { SecurityState } from '../security.slice'
import { PayloadAction } from '@reduxjs/toolkit'

const SecurityReducer = {
    setNotificationsCounts: (
        state: SecurityState,
        action: PayloadAction<any>
    ): void => {
        state.initData.processes.notifications.totalCount =
            action.payload.totalCount || 0
        state.initData.processes.notifications.unreadCount =
            action.payload.unreadCount || 0
    },
    setInitData: (state: SecurityState, action: PayloadAction<any>): void => {
        state.initData = action.payload
    },
    setLoggedInUser: (
        state: SecurityState,
        action: PayloadAction<any>
    ): void => {
        state.user = action.payload
    },
    setLanguages: (state: SecurityState, action: PayloadAction<any>): void => {
        state.initData.languages = action.payload
    },
    setAvailableModules: (
        state: SecurityState,
        action: PayloadAction<any>
    ): void => {
        state.initData.available_modules = action.payload
    },
}

export default SecurityReducer
